export const defaultThemes = [
  {
    name: "Default",
    value: "light",
    colors: {
      "--background": "342, 70%, 100%",
      "--foreground": "342, 71%, 5%",
      "--muted": "342, 24%, 91%",
      "--muted-foreground": "342, 0%, 30%",
      "--popover": "342, 70%, 100%",
      "--popover-foreground": "342, 71%, 5%",
      "--card": "342, 70%, 100%",
      "--card-foreground": "342, 71%, 5%",
      "--border": "342, 15%, 95%",
      "--input": "342, 15%, 95%",
      "--primary": "85, 49%, 58%",
      "--primary-foreground": "210, 40%, 98%",
      "--secondary": "112, 60%, 20%",
      "--secondary-foreground": "85, 49%, 58%",
      "--accent": "342, 8%, 83%",
      "--accent-foreground": "342, 8%, 23%",
      "--destructive": "9, 93%, 21%",
      "--destructive-foreground": "9, 93%, 81%",
      "--neutral": " 262 56% 50%",
      "--neutral-foreground": "250 80% 95%",
      "--ring": "342, 98%, 29%",
      "--chart-1": "342, 98%, 29%",
      "--chart-2": "342, 8%, 83%",
      "--chart-3": "342, 8%, 83%",
      "--chart-4": "342, 8%, 86%",
      "--chart-5": "342, 101%, 29%",
    },
  },
  {
    name: "Dark",
    value: "dark",
    colors: {
      "--background": "342, 33%, 3%",
      "--foreground": "342, 30%, 97%",
      "--muted": "342, 24%, 9%",
      "--muted-foreground": "342, 0%, 70%",
      "--popover": "342, 33%, 3%",
      "--popover-foreground": "342, 30%, 97%",
      "--card": "342, 33%, 3%",
      "--card-foreground": "342, 30%, 97%",
      "--border": "342, 15%, 12%",
      "--input": "342, 15%, 12%",
      "--primary": "210, 40%, 98%",
      "--primary-foreground": "85, 49%, 58%",
      "--secondary": "217.2, 32.6%, 17.5%",
      "--secondary-foreground": "210, 40%, 98%",
      "--accent": "342, 7%, 8%",
      "--accent-foreground": "342, 7%, 68%",
      "--destructive": "9, 93%, 49%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "260 30% 70%",
      "--neutral-foreground": "260 60% 10%",
      "--ring": "342, 98%, 29%",
      "--chart-1": "342, 98%, 29%",
      "--chart-2": "342, 7%, 8%",
      "--chart-3": "342, 7%, 8%",
      "--chart-4": "342, 7%, 11%",
      "--chart-5": "342, 101%, 29%",
    },
  },
  {
    name: "Vintage",
    value: "vintage",
    colors: {
      "--primary": "34, 57%, 50%",
      "--primary-foreground": "0, 0%, 100%",
      "--secondary": "20, 30%, 60%",
      "--secondary-foreground": "0, 0%, 100%",
      "--accent": "10, 40%, 50%",
      "--accent-foreground": "0, 0%, 100%",
      "--border": "30, 20%, 70%",
      "--background": "0, 0%, 95%",
      "--foreground": "0, 0%, 10%",
      "--card": "0, 0%, 90%",
      "--card-foreground": "0, 0%, 10%",
      "--popover": "0, 0%, 90%",
      "--popover-foreground": "0, 0%, 10%",
      "--muted": "0, 0%, 80%",
      "--muted-foreground": "0, 0%, 40%",
      "--destructive": "350, 70%, 50%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "30 20% 55%",
      "--neutral-foreground": "0 0% 15%",
      "--ring": "34, 57%, 50%",
      "--input": "0, 0%, 85%",
      "--chart-1": "34, 57%, 50%",
      "--chart-2": "20, 30%, 60%",
      "--chart-3": "10, 40%, 50%",
      "--chart-4": "30, 20%, 70%",
      "--chart-5": "0, 0%, 95%",
    },
  },
  {
    name: "One Dark Pro",
    value: "one-dark-pro",
    colors: {
      "--primary": "220, 13%, 18%",
      "--primary-foreground": "220, 14%, 96%",
      "--background": "220, 13%, 10%",
      "--foreground": "220, 14%, 96%",
      "--accent": "340, 82%, 52%",
      "--accent-foreground": "0, 0%, 100%",
      "--secondary": "200, 10%, 30%",
      "--secondary-foreground": "0, 0%, 100%",
      "--muted": "220, 10%, 30%",
      "--muted-foreground": "220, 14%, 70%",
      "--card": "220, 13%, 12%",
      "--card-foreground": "220, 14%, 96%",
      "--popover": "220, 13%, 10%",
      "--popover-foreground": "220, 14%, 96%",
      "--border": "220, 10%, 20%",
      "--input": "220, 10%, 20%",
      "--destructive": "0, 80%, 55%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "220 10% 40%",
      "--neutral-foreground": "220 14% 90%",
      "--ring": "340, 82%, 52%",
      "--chart-1": "340, 82%, 52%",
      "--chart-2": "200, 10%, 40%",
      "--chart-3": "60, 100%, 50%",
      "--chart-4": "120, 40%, 40%",
      "--chart-5": "280, 40%, 50%",
    },
  },
  {
    name: "Dracula Official",
    value: "dracula",
    colors: {
      "--primary": "225 25% 16%",
      "--primary-foreground": "231 15% 90%",
      "--background": "231 15% 12%",
      "--foreground": "231 15% 90%",
      "--accent": "330 100% 71%",
      "--accent-foreground": "231 15% 12%",
      "--secondary": "265 89% 78%",
      "--secondary-foreground": "0 0% 100%",
      "--muted": "231 15% 25%",
      "--muted-foreground": "231 15% 70%",
      "--card": "231 15% 14%",
      "--card-foreground": "231 15% 90%",
      "--popover": "231 15% 12%",
      "--popover-foreground": "231 15% 90%",
      "--border": "231 15% 20%",
      "--input": "231 15% 20%",
      "--destructive": "0 100%, 67%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "260 20% 40%",
      "--neutral-foreground": "231 15% 95%",
      "--ring": "265, 89%, 78%",
      "--chart-1": "330, 100%, 71%",
      "--chart-2": "265, 89%, 78%",
      "--chart-3": "190, 100%, 70%",
      "--chart-4": "100, 100%, 75%",
      "--chart-5": "40, 100%, 80%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Catppuccin Macchiato",
    value: "catppuccin-macchiato",
    colors: {
      "--primary": "230, 30%, 20%",
      "--primary-foreground": "230, 30%, 95%",
      "--background": "230, 30%, 10%",
      "--foreground": "230, 30%, 95%",
      "--accent": "265, 60%, 70%",
      "--accent-foreground": "0, 0%, 100%",
      "--secondary": "300, 30%, 60%",
      "--secondary-foreground": "0, 0%, 100%",
      "--muted": "230, 20%, 30%",
      "--muted-foreground": "230, 20%, 70%",
      "--card": "230, 30%, 12%",
      "--card-foreground": "230, 30%, 95%",
      "--popover": "230, 30%, 10%",
      "--popover-foreground": "230, 30%, 95%",
      "--border": "230, 20%, 20%",
      "--input": "230, 20%, 20%",
      "--destructive": "0, 80%, 60%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "230 15% 35%",
      "--neutral-foreground": "230 30% 92%",
      "--ring": "265, 60%, 70%",
      "--chart-1": "265, 60%, 70%",
      "--chart-2": "300, 30%, 60%",
      "--chart-3": "200, 50%, 50%",
      "--chart-4": "180, 50%, 60%",
      "--chart-5": "100, 40%, 50%",
    },
  },
  {
    name: "Ayu Mirage",
    value: "ayu-mirage",
    colors: {
      "--primary": "220, 16%, 22%",
      "--primary-foreground": "42, 100%, 80%",
      "--background": "220, 16%, 15%",
      "--foreground": "42, 100%, 85%",
      "--accent": "42, 100%, 70%",
      "--accent-foreground": "220, 16%, 15%",
      "--secondary": "280, 13%, 35%",
      "--secondary-foreground": "0, 0%, 100%",
      "--muted": "220, 12%, 28%",
      "--muted-foreground": "220, 12%, 65%",
      "--card": "220, 16%, 18%",
      "--card-foreground": "42, 100%, 85%",
      "--popover": "220, 16%, 15%",
      "--popover-foreground": "42, 100%, 85%",
      "--border": "220, 12%, 25%",
      "--input": "220, 12%, 25%",
      "--destructive": "0, 80%, 60%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "42 30% 40%",
      "--neutral-foreground": "42 100% 85%",
      "--ring": "42, 100%, 70%",
      "--chart-1": "42, 100%, 70%",
      "--chart-2": "195, 70%, 60%",
      "--chart-3": "330, 60%, 70%",
      "--chart-4": "120, 40%, 55%",
      "--chart-5": "280, 40%, 65%",
    },
  },
  {
    name: "Tokyo Night",
    value: "tokyo-night",
    colors: {
      "--primary": "230, 20%, 18%",
      "--primary-foreground": "220, 100%, 85%",
      "--background": "230, 20%, 10%",
      "--foreground": "220, 100%, 85%",
      "--accent": "270, 100%, 75%",
      "--accent-foreground": "230, 20%, 10%",
      "--secondary": "195, 100%, 75%",
      "--secondary-foreground": "0, 0%, 100%",
      "--muted": "230, 15%, 25%",
      "--muted-foreground": "220, 14%, 70%",
      "--card": "230, 20%, 12%",
      "--card-foreground": "220, 100%, 85%",
      "--popover": "230, 20%, 10%",
      "--popover-foreground": "220, 100%, 85%",
      "--border": "230, 15%, 22%",
      "--input": "230, 15%, 22%",
      "--destructive": "0, 80%, 60%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "230 20% 40%",
      "--neutral-foreground": "220 100% 90%",
      "--ring": "270, 100%, 75%",
      "--chart-1": "270, 100%, 75%",
      "--chart-2": "195, 100%, 75%",
      "--chart-3": "45, 100%, 70%",
      "--chart-4": "120, 60%, 50%",
      "--chart-5": "330, 60%, 65%",
    },
  },
  {
    name: "Monokai Pro",
    value: "monokai-pro",
    colors: {
      "--primary": "240, 10%, 20%",
      "--primary-foreground": "60, 100%, 85%",
      "--background": "240, 10%, 12%",
      "--foreground": "60, 100%, 85%",
      "--accent": "325, 100%, 70%",
      "--accent-foreground": "240, 10%, 12%",
      "--secondary": "280, 100%, 75%",
      "--secondary-foreground": "0, 0%, 100%",
      "--muted": "240, 10%, 25%",
      "--muted-foreground": "240, 10%, 65%",
      "--card": "240, 10%, 15%",
      "--card-foreground": "60, 100%, 85%",
      "--popover": "240, 10%, 12%",
      "--popover-foreground": "60, 100%, 85%",
      "--border": "240, 10%, 22%",
      "--input": "240, 10%, 22%",
      "--destructive": "0, 80%, 55%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "240 8% 35%",
      "--neutral-foreground": "60 100% 90%",
      "--ring": "325, 100%, 70%",
      "--chart-1": "325, 100%, 70%",
      "--chart-2": "280, 100%, 75%",
      "--chart-3": "120, 60%, 60%",
      "--chart-4": "60, 100%, 65%",
      "--chart-5": "200, 100%, 70%",
    },
  },
  {
    name: "Houston",
    value: "houston",
    colors: {
      "--primary": "205, 60%, 20%",
      "--primary-foreground": "160, 100%, 80%",
      "--background": "210, 60%, 10%",
      "--foreground": "160, 100%, 85%",
      "--accent": "160, 100%, 70%",
      "--accent-foreground": "205, 60%, 10%",
      "--secondary": "200, 40%, 45%",
      "--secondary-foreground": "0, 0%, 100%",
      "--muted": "205, 30%, 25%",
      "--muted-foreground": "160, 20%, 70%",
      "--card": "205, 60%, 13%",
      "--card-foreground": "160, 100%, 85%",
      "--popover": "210, 60%, 10%",
      "--popover-foreground": "160, 100%, 85%",
      "--border": "205, 30%, 28%",
      "--input": "205, 30%, 28%",
      "--destructive": "0, 70%, 60%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "200 25% 35%",
      "--neutral-foreground": "160 40% 90%",
      "--ring": "160, 100%, 70%",
      "--chart-1": "160, 100%, 70%",
      "--chart-2": "200, 60%, 65%",
      "--chart-3": "280, 40%, 70%",
      "--chart-4": "100, 60%, 60%",
      "--chart-5": "40, 90%, 60%",
    },
  },
  {
    name: "Aofuji Light",
    value: "aofuji-light",
    colors: {
      "--primary": "230, 60%, 95%",
      "--primary-foreground": "230, 80%, 25%",
      "--background": "0, 0%, 100%",
      "--foreground": "230, 60%, 25%",
      "--accent": "230, 80%, 60%",
      "--accent-foreground": "0, 0%, 100%",
      "--secondary": "220, 30%, 85%",
      "--secondary-foreground": "230, 80%, 25%",
      "--muted": "220, 30%, 90%",
      "--muted-foreground": "220, 15%, 50%",
      "--card": "0, 0%, 100%",
      "--card-foreground": "230, 60%, 25%",
      "--popover": "230, 100%, 98%",
      "--popover-foreground": "230, 80%, 25%",
      "--border": "220, 30%, 85%",
      "--input": "220, 30%, 85%",
      "--destructive": "0, 70%, 60%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "230 30% 85%",
      "--neutral-foreground": "230 60% 15%",
      "--ring": "230, 80%, 60%",
      "--chart-1": "230, 80%, 60%",
      "--chart-2": "180, 70%, 60%",
      "--chart-3": "330, 70%, 65%",
      "--chart-4": "45, 90%, 65%",
      "--chart-5": "270, 60%, 60%",
    },
  },
  {
    name: "NotFlask Dark",
    value: "notflask-dark",
    colors: {
      "--primary": "220, 15%, 18%",
      "--primary-foreground": "210, 100%, 90%",
      "--background": "220, 15%, 12%",
      "--foreground": "210, 100%, 90%",
      "--accent": "280, 90%, 70%",
      "--accent-foreground": "220, 15%, 12%",
      "--secondary": "200, 70%, 70%",
      "--secondary-foreground": "0, 0%, 100%",
      "--muted": "220, 10%, 30%",
      "--muted-foreground": "210, 10%, 65%",
      "--card": "220, 15%, 14%",
      "--card-foreground": "210, 100%, 90%",
      "--popover": "220, 15%, 12%",
      "--popover-foreground": "210, 100%, 90%",
      "--border": "220, 10%, 25%",
      "--input": "220, 10%, 25%",
      "--destructive": "0, 80%, 55%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "220 10% 40%",
      "--neutral-foreground": "210 80% 95%",
      "--ring": "280, 90%, 70%",
      "--chart-1": "280, 90%, 70%",
      "--chart-2": "200, 70%, 70%",
      "--chart-3": "100, 60%, 60%",
      "--chart-4": "40, 90%, 65%",
      "--chart-5": "320, 60%, 60%",
    },
  },
  {
    name: "NotFlask Light",
    value: "notflask-light",
    colors: {
      "--primary": "210, 50%, 95%",
      "--primary-foreground": "220, 100%, 30%",
      "--background": "0, 0%, 100%",
      "--foreground": "210, 50%, 25%",
      "--accent": "280, 90%, 60%",
      "--accent-foreground": "0, 0%, 100%",
      "--secondary": "200, 80%, 75%",
      "--secondary-foreground": "210, 50%, 25%",
      "--muted": "210, 40%, 90%",
      "--muted-foreground": "210, 30%, 50%",
      "--card": "0, 0%, 100%",
      "--card-foreground": "210, 50%, 25%",
      "--popover": "210, 100%, 98%",
      "--popover-foreground": "220, 100%, 30%",
      "--border": "210, 40%, 85%",
      "--input": "210, 40%, 85%",
      "--destructive": "0, 70%, 60%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "210 30% 80%",
      "--neutral-foreground": "220 100% 20%",
      "--ring": "280, 90%, 60%",
      "--chart-1": "280, 90%, 60%",
      "--chart-2": "200, 80%, 70%",
      "--chart-3": "100, 60%, 60%",
      "--chart-4": "45, 90%, 65%",
      "--chart-5": "320, 60%, 65%",
    },
  },
  {
    name: "Valorant Based",
    value: "valorant",
    colors: {
      "--primary": "0, 100%, 35%",
      "--primary-foreground": "0, 0%, 100%",
      "--background": "230, 10%, 8%",
      "--foreground": "0, 0%, 95%",
      "--accent": "160, 60%, 45%",
      "--accent-foreground": "230, 10%, 8%",
      "--secondary": "0, 0%, 40%",
      "--secondary-foreground": "0, 0%, 100%",
      "--muted": "230, 10%, 15%",
      "--muted-foreground": "0, 0%, 60%",
      "--card": "230, 10%, 10%",
      "--card-foreground": "0, 0%, 95%",
      "--popover": "230, 10%, 8%",
      "--popover-foreground": "0, 0%, 95%",
      "--border": "230, 10%, 20%",
      "--input": "230, 10%, 20%",
      "--destructive": "0, 80%, 60%",
      "--destructive-foreground": "0, 0%, 100%",
      "--neutral": "230 8% 30%",
      "--neutral-foreground": "0 0% 95%",
      "--ring": "160, 60%, 45%",
      "--chart-1": "0, 100%, 35%",
      "--chart-2": "160, 60%, 45%",
      "--chart-3": "0, 0%, 60%",
      "--chart-4": "45, 100%, 60%",
      "--chart-5": "280, 70%, 65%",
    },
  },
];
